// extracted by mini-css-extract-plugin
export default {"menuItem__link":"headerMenuItem_menuItem__link__HJXv4","menuItem__link_active":"headerMenuItem_menuItem__link_active__LnPf1"};